import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-concept-create',
  template: `
  <div class="row">
  <div class="col-sm-11 offset-sm-1 col-md-11 offset-md-1 col-lg-8 offset-lg-4 col-xl-9 offset-xl-3 mt-5">
      
        <div class="row mb-4 mt-4">
          <div class="col-md-9">
            <h1>Concepto</h1>
            <p>Configura los conceptos para los recibos de pago.</p>
          </div>
          <div class="col-md-3 text-end mt-4">
            
          </div>
          <xng-breadcrumb ></xng-breadcrumb>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="card border-0 rounded-4 shadow">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-md-12">
                    <h4>Agregar concepto</h4>
                    <p>Configura los conceptos de pago con los siguientes campos.</p>
                    <app-form-payment-concept (conceptData)="createConcept($event)" [loading]="loading"></app-form-payment-concept>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ConceptCreateComponent {
  loading: boolean = false;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {

  }

  createConcept(event: any) {
    this.store.createPaymentConcept(event).subscribe({
      next: (data: any) => {
        console.log(data);
        this.toastr.success('Servicio creado correctamente.');
        this.router.navigate(['/pagos/conceptos']);
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al crear el servicio.');
      }
    });
  }
}
